/**
 * ProfileService by karora on 20/03/17.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SocialProfile } from '../types/social-profile';
import { StandardResponse } from '../types/standard-response';
import { UserProfile } from '../types/user-profile';
import { ApiService } from './api.service';

@Injectable()
export class ProfileService {
  private static userProfile = <UserProfile>{
    'id': '',
    'review': false,
    'social': <SocialProfile>{
      'id': '',
      'email': '',
      'verified_email': '',
      'name': 'unknown',
      'given_name': '',
      'family_name': '',
      'locale': '',
      'picture': '',
    },
    'type': 0,
    'programme_rights': {
    }
  };
  private static programmes = <string[]>{}
  private static sessionCookie: string;

  constructor(private api: ApiService) {
    ProfileService.sessionCookie = ProfileService.getCookieValue("VOXSession");
    // set token if saved in local storage
    try {
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser) {
        ProfileService.userProfile = currentUser.profile;
        if (ProfileService.userProfile.programme_rights) {
          ProfileService.programmes = Object.keys(ProfileService.userProfile.programme_rights);
          console.log("Got access for programmes: " + ProfileService.programmes);
        } else {
          console.log("programme_rights was null :-(");
          console.log(JSON.stringify(ProfileService.userProfile, null, 2));
        }
      }
    } catch (e) {
      console.log("Error getting stored profile :-(" + e);
    }
  }

  static getCookieValue(a: string): string {
    let b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

  public static IsLoggedIn(): boolean {
    return (window as any).loggedIn === 'youbetcha';
  }

  GetProfile(): Observable<UserProfile> {
    return this.api.Get('/auth/profile').pipe(map(ProfileService.handleProfileResponse));
  }

  private static handleProfileResponse(response: StandardResponse): UserProfile {
    try {
      let status = response && response.status;
      if (status === 'success' && response.data) {
        ProfileService.userProfile = response.data;
        ProfileService.programmes = response.data.programme_rights
          ? Object.keys(response.data.programme_rights)
          : [];
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        currentUser.profile = response.data;
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
      }
    } catch (e) {
      console.log('Error getting user profile :-(');
    }
    return ProfileService.userProfile;
  }

  static logout(): void {
    // clear token remove user from local storage to log user out
    (<any>window).LoggedIn = 'nope';
    ApiService.Forget();
    ProfileService.userProfile = null;
    localStorage.removeItem('currentUser');
  }

  public static ProgrammeRights(programmeID: string): string {
    if (ProfileService.userProfile.programme_rights && ProfileService.userProfile.programme_rights[programmeID]) {
      return ProfileService.userProfile.programme_rights[programmeID];
    }
    return "";
  }

  public static CanReview(): boolean {
    try {
      // console.log("Profile: " + JSON.stringify(ProfileService.userProfile, null, 2));
      if (ProfileService.userProfile && ProfileService.userProfile.id) {
        if (ProfileService.userProfile.review || ProfileService.userProfile.administer) return true;
        if (ProfileService.programmes.length < 1) return false;
        for (let k of ProfileService.programmes) {
          let rights = ProfileService.ProgrammeRights(k);
          if (rights.indexOf("A") >= 0) return true;
          if (rights.indexOf("r") >= 0) return true;
        }
      }
    } catch (e) {
      console.log("CanReview error:", e.message);
    }
    return false;
  }

  public static CanAdminister(): boolean {
    try {
      if (ProfileService.userProfile && ProfileService.userProfile.id) {
        if (ProfileService.userProfile.administer) return true;
        if (ProfileService.programmes.length < 1) return false;
        for (let k of ProfileService.programmes) {
          let rights = ProfileService.ProgrammeRights(k);
          if (rights.indexOf("A") >= 0) return true;
        }
      }
    } catch (e) {
      console.log("CanAdminister error:", e.message);
    }
    return false;
  }

  public static CanAdministerAll(): boolean {
    try {
      if (ProfileService.userProfile && ProfileService.userProfile.id) {
        if (ProfileService.userProfile.administer) return true;
      }
    } catch (e) {
      console.log(e.message);
    }
    return false;
  }

  public static CanReviewAll(): boolean {
    try {
      if (ProfileService.userProfile && ProfileService.userProfile.id) {
        if (ProfileService.userProfile.review) return true;
      }
    } catch (e) {
      console.log(e.message);
    }
    return false;
  }

  public static CanAdministerProgramme(programmeID: number): boolean {
    try {
      if (ProfileService.userProfile && ProfileService.userProfile.id) {
        if (ProfileService.userProfile.administer) return true;
        let rights = ProfileService.ProgrammeRights("" + programmeID);
        if (rights.indexOf("A") >= 0) return true;
      }
    } catch (e) {
      console.log(e.message);
    }
    return false;
  }

  public static CurrentUserProfile(): UserProfile {
    try {
      if (ProfileService.userProfile && ProfileService.userProfile.id) {
        return ProfileService.userProfile;
      }
    } catch (e) {
      console.log(e.message);
    }
    return null;
  }

}
